import {EditorView} from "prosemirror-view";
import {EditorState, Transaction} from "prosemirror-state";

import {TriggerActionCommandAdditionalParams} from "./types";
import {insertNode} from "./utils";


import {schema} from "../../config/schema";


export const insertList = (type: string) => {
    return (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
        const listNode = schema.nodes.list.createAndFill({type: type})!;

        return insertNode(listNode, state, dispatch, view, additionalParams);
    }
}